import React, { createContext, ReactNode, useState } from 'react';
import { ICrumb } from '../interfaces/ICrumb';
import { IMensagem } from '../interfaces/IMensage';
import { IMunicipio } from 'interfaces/IMunicipio';

export interface ArrecadacaoContext {
  crumbs: ICrumb[];
  setCrumbs: React.Dispatch<React.SetStateAction<ICrumb[]>>;
  mensagens: IMensagem[];
  setMensagens: React.Dispatch<React.SetStateAction<IMensagem[]>>;
  idBalneario: number;
  setIdBalneario: React.Dispatch<React.SetStateAction<number>>;
  idOutrosRegimes: number;
  setIdOutrosRegimes: React.Dispatch<React.SetStateAction<number>>;
  idNCMOutrosRegimes: number;
  setIdNCMOutrosRegimes: React.Dispatch<React.SetStateAction<number>>;
  numeroProcesso: string;
  setNumeroProcesso: React.Dispatch<React.SetStateAction<string>>;
  idNCMPrimeiroAdquirente: number;
  setIdNCMPrimeiroAdquirente: React.Dispatch<React.SetStateAction<number>>;
  substancia: string;
  setSubstancia: React.Dispatch<React.SetStateAction<string>>;
  municipio: IMunicipio;
  setMunicipio: React.Dispatch<React.SetStateAction<IMunicipio>>;
  competenciaMes: number;
  setCompetenciaMes: React.Dispatch<React.SetStateAction<number>>;
  competenciaAno: number;
  setCompetenciaAno: React.Dispatch<React.SetStateAction<number>>;
}

// Crie o contexto com um valor inicial
export const ArrecadacaoContext = createContext<ArrecadacaoContext | undefined>(undefined);

// Defina o tipo para as propriedades do GlobalProvider
interface GlobalProviderProps {
  children: ReactNode;
}

export const ArrecadacaoProvider = ({ children }: GlobalProviderProps) => {
  const [crumbs, setCrumbs] = useState<ICrumb[]>([]);
  const [mensagens, setMensagens] = useState<IMensagem[]>([]);

  const [idBalneario, setIdBalneario] = useState<number>(-1);

  const [idOutrosRegimes, setIdOutrosRegimes] = useState<number>(-1);
  const [idNCMOutrosRegimes, setIdNCMOutrosRegimes] = useState<number>(-1);
  const [numeroProcesso, setNumeroProcesso] = useState<string>('');
  const [substancia, setSubstancia] = useState<string>('');
  const [municipio, setMunicipio] = useState<IMunicipio>({ nome: '', uf: '', codigoIBGE: 0 });
  const [competenciaMes, setCompetenciaMes] = useState<number>(-1);
  const [competenciaAno, setCompetenciaAno] = useState<number>(-1);

  const [idNCMPrimeiroAdquirente, setIdNCMPrimeiroAdquirente] = useState<number>(-1);

  return (
    <ArrecadacaoContext.Provider
      value={{
        crumbs,
        setCrumbs,
        mensagens,
        setMensagens,
        idBalneario,
        setIdBalneario,
        idOutrosRegimes,
        setIdOutrosRegimes,
        idNCMOutrosRegimes,
        setIdNCMOutrosRegimes,
        numeroProcesso,
        setNumeroProcesso,
        idNCMPrimeiroAdquirente,
        setIdNCMPrimeiroAdquirente,
        substancia,
        setSubstancia,
        municipio,
        setMunicipio,
        competenciaMes,
        setCompetenciaMes,
        competenciaAno,
        setCompetenciaAno,
      }}
    >
      {children}
    </ArrecadacaoContext.Provider>
  );
};
